import * as React from "react";

import { Link } from "gatsby";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Toolbar from "@mui/material/Toolbar";
import hdate from "human-date";
interface CBreadCrumbProps {
    title: string;
    date?: string;
}

export default function CBreadcrumb({ title, date }: CBreadCrumbProps) {
    return (
        <Toolbar
            component="nav"
            variant="regular"
            sx={{
                overflowX: "auto",
            }}
        >
            <Breadcrumbs aria-label="breadcrumb" separator="»">
                <Link
                    color="inherit"
                    to="/"
                >
                    <Typography variant="body2">
                        <HomeIcon /> Home
                    </Typography>
                </Link>
                {date && (
                    <Typography
                        variant="body2"
                        sx={{ textTransform: "capitalize" }}
                    >
                        {hdate.prettyPrint(date)}
                    </Typography>
                )}
                <Typography
                    variant="body2"
                    sx={{ textTransform: "capitalize" }}
                >
                    {title}
                </Typography>
            </Breadcrumbs>
        </Toolbar>
    );
}
